import { useState, useRef } from 'react' // 1. Added useRef
import './App.css'
import gears from './assets/gears.gif';

function App() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);
  
  // 2. This ref holds our connection so we can kill "ghost" listeners
  const eventSourceRef = useRef(null);





  const sendMessage = async () => {
    if (!input.trim()) return;

    // 3. CLEANUP: If a stream is already open, close it before starting a new one
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
    }

    const currentInput = input;
    setInput('');
    setMessages(prev => [...prev, { role: 'user', text: currentInput }]);
    setIsLoading(true);
    setIsTyping(true);  // Lights up your gears.gif

    const url = `/api/chat/stream?message=${encodeURIComponent(currentInput)}`;
    
    
    const eventSource = new EventSource(url);
    eventSourceRef.current = eventSource; // Store it in the ref

    // Create the AI message placeholder
    setMessages(prev => [...prev, { role: 'ai', text: '' }]);

eventSource.onmessage = (event) => {
  setIsLoading(false);
  

  setMessages((prev) => {
    const updatedMessages = [...prev];
    const lastIndex = updatedMessages.length - 1;

    if (updatedMessages[lastIndex] && updatedMessages[lastIndex].role === 'ai') {
      // FIX: In SSE, a message that is just a space might come through 
      // as an empty event.data or stripped by the browser. 
      // If the curl command showed spaces, we can force them back here:
      let chunk = event.data;
      
      // If the event.data is empty but the event fired, it's often a space
      if (chunk === "" && event.type === "message") {
        chunk = " "; 
      }else
	chunk=chunk+" ";	
      // Append raw chunk
      updatedMessages[lastIndex].text = updatedMessages[lastIndex].text + chunk;
    }
    
    return updatedMessages;
  });
};
    eventSource.onerror = (error) => {
      console.error("Stream closed.");
      eventSource.close();
      setIsTyping(false); // Hides your gears.gif
      eventSourceRef.current = null;
      setIsLoading(false);
      
		      // SIMPLE JUMP TO BOTTOM
		  const anchor = document.getElementById('scroll-anchor');
		  if (anchor) {
		    anchor.scrollIntoView(); 
		  }
      
      
    };
  };



  return (
    <div className="app-container">
<header>
  {/* This container keeps everything in one line */}
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    gap: '15px',
    borderBottom: '1px solid #ddd', // Optional: adds a clean line under your header
    paddingBottom: '10px'
  }}>
    
    <h1 style={{ margin: 0 }}>Resume AI Assistant [Beta]</h1>
    
    
    {/* The Gears Container */}
    <div style={{ 
      visibility: isTyping ? 'visible' : 'hidden', 
      display: 'flex', 
      alignItems: 'center' 
    }}>
      <img 
        src={gears} 
        alt="Processing..." 
        style={{ width: '40px', height: '40px' }} 
      />
    </div>

  </div>
</header>
      <div className="chat-window">
        {messages.map((msg, idx) => (
          <div key={idx} className={`message ${msg.role}`} style={{ whiteSpace: 'pre-wrap' }}>
            <strong>{msg.role === 'user' ? 'You' : 'AI'}:</strong> {msg.text}
          </div>
        ))}
        {isLoading && <div className="message ai"><em>This AI is experimental, please wait for gears to stop, it can take a few minutes...</em></div>}
        
        {/* THIS IS YOUR SCROLL DOWN LANDMARK */}
  	<div id="scroll-anchor"></div>
      </div>

      <div className="input-area">
        <input 
          value={input} 
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
          placeholder="Ask about Carlos' Resume..."
        />
        <button onClick={sendMessage} disabled={isLoading}>
          {isLoading ? '...' : 'Send'}
        </button>
      </div>
    </div>
  )
}

export default App
